const modifyProposedEvent = function ({ commit }, { id, field, value }) {
  commit("MODIFY_EVENT", { id, field, value });
};

export default modifyProposedEvent;
